import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { convertAmount, dotFormatter, roundNumber } from '../../../../../../../helpers';
import { useStore, useTranslation } from '../../../../../../../hooks';
import { FreeDropTierFreeBet } from '../../../../../../../models';
import { T } from '../../../../../../../constants';

interface LevelsTableRowColProps {
  claimLimitPerDrop?: number;
  freeBets: Array<FreeDropTierFreeBet>;
}

export const LevelsTableRowCol: React.FC<LevelsTableRowColProps> = observer(({
  freeBets,
  claimLimitPerDrop = 1
}) => {

  const { gameStore, freeDropStore  } = useStore();
  const { currencySymbol, precision, currencyCode, rate } = gameStore;
  const { freeDropInfo } = freeDropStore;

  const t = useTranslation();

  const userCurrencyFreeBet = useMemo(() => {
    return freeBets.find((freebet) => freebet.currency === currencyCode);
  }, [freeBets, currencyCode]);

  const campaignCurrencyFreeBet = useMemo(() => {
    return freeBets.find((freebet) => freebet.currency === freeDropInfo?.currency);
  }, [freeBets, freeDropInfo]);

  const win = useMemo(() => {
    let amount: number;
    if (userCurrencyFreeBet) {
      amount = (userCurrencyFreeBet?.amount || 0) * (userCurrencyFreeBet?.count || 0) * claimLimitPerDrop;
      return roundNumber(amount, precision);
    }
    amount = (campaignCurrencyFreeBet?.coinAmount || 0) * (campaignCurrencyFreeBet?.count || 0) * claimLimitPerDrop;
    return convertAmount(amount, rate, precision);
  }, [userCurrencyFreeBet, campaignCurrencyFreeBet, claimLimitPerDrop, rate, precision]);

  const turnover = useMemo(() => {
    let amount: number;
    if (userCurrencyFreeBet) {
      amount = userCurrencyFreeBet?.goal || 0;
      return roundNumber(amount, precision);
    }
    amount = campaignCurrencyFreeBet?.goalCoinAmount || 0;
    return convertAmount(amount, rate, precision);
  }, [userCurrencyFreeBet, campaignCurrencyFreeBet, rate, precision]);

  return (
    <div className="free-drop-popup-table-content-clm">
      <p className="free-drop-popup-table-content-info-txt">
        {t(T.TURNOVER)}:
      </p>
      <p className="free-drop-popup-table-content-info-amount">
        {dotFormatter(turnover)}{currencySymbol}
      </p>
      <p className="free-drop-popup-table-content-info-txt">
        {t(T.WIN_UP_TO)}:
      </p>
      <p className="free-drop-popup-table-content-info-amount">
        {dotFormatter(win)}{currencySymbol}
      </p>
    </div>
  );
});
